import { axiosClient } from "../core/services/axiosInstance";
import { jwtDecode } from "jwt-decode";
import { theme } from "../styles/theme";

const CryptoJS = require("crypto-js");

export const encrypt = (message) => {
  const key = process.env.REACT_APP_CRYPT_KEY;
  const iv = process.env.REACT_APP_CRYPT_IV;

  const encryptedData = CryptoJS.AES.encrypt(
    message,
    CryptoJS.enc.Utf8.parse(key),
    {
      iv: CryptoJS.enc.Utf8.parse(iv),
      keySize: 256,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return encryptedData.toString();
};

export const decrypt = (encryptedMessage) => {
  const key = process.env.REACT_APP_CRYPT_KEY;
  const iv = process.env.REACT_APP_CRYPT_IV;

  const decryptedData = CryptoJS.AES.decrypt(
    encryptedMessage,
    CryptoJS.enc.Utf8.parse(key),
    {
      iv: CryptoJS.enc.Utf8.parse(iv),
      keySize: 256,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return decryptedData.toString(CryptoJS.enc.Utf8);
};

const setLocalUser = (user) => {
  localStorage.setItem("user", JSON.stringify(user));
};

export const getToken = () => {
  const user = localStorage.getItem("user");

  return user;
};
export const getUserInfo = () => {
  const user = localStorage.getItem("user")
    ? jwtDecode(localStorage.getItem("user"))
    : {
        nameid: "",
        unique_name: "",
        email: "",
        role: "",
        nbf: null,
        exp: null,
        iat: null,
      };
  return user;
};

export const saveTabChange = (key) => {
  localStorage.setItem("lastActiveTab", key);
};

export const getLabelById = (id, options) => {
  const item = options.find((option) => option.value === id);
  return item ? item.label : null;
};

export const getLogo = () => {
  const logo = localStorage.getItem("urlLogo")
    ? localStorage.getItem("urlLogo")
    : null;
  return logo;
};

export const isSuperAdmin = () => {
  const user = localStorage.getItem("user")
    ? jwtDecode(localStorage.getItem("user"))
    : {
        rol: "",
      };
  return user.rol === "SuperAdmin";
};

export const isAdmin = () => {
  const user = localStorage.getItem("user")
    ? jwtDecode(localStorage.getItem("user"))
    : {
        rol: "",
      };
  return user.rol === "Admin";
};

export const isRegular = () => {
  const user = localStorage.getItem("user")
    ? jwtDecode(localStorage.getItem("user"))
    : {
        rol: "",
      };
  return user.rol === "User";
};

export const userClinic = () => {
  const user = localStorage.getItem("user")
    ? jwtDecode(localStorage.getItem("user"))
    : {
        clinic: "",
        id: "",
      };
  return user.clinic;
};

export const uploadFiles = async (file, url) => {
  const formData = new FormData();
  formData.append("File", file);
  return axiosClient.post(url, formData);
};

export const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const base64String = event.target.result.split(",")[1];
      resolve(base64String);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
};

export const createURLFromBase64 = (base64String, mimeType) => {
  const byteCharacters = atob(base64String);
  const byteArray = new Uint8Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteArray[i] = byteCharacters.charCodeAt(i);
  }

  const blob = new Blob([byteArray], { type: mimeType });
  const url = URL.createObjectURL(blob);

  return url;
};

export const download = async (url, filename, instance, token) =>
  instance
    .post(
      url,
      {},
      {
        responseType: "blob",
        headers: { Authorization: token },
      }
    )
    .then(
      (response) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        a.href = pdfUrl;
        a.setAttribute("download", `${filename}`);
        document.body.appendChild(a);
        a.click();
        a.remove();
      },
      (e) => {
        return Promise.reject(e);
      }
    );

export const downloadFile = async (url, filename, instance, token) =>
  instance
    .get(url, {
      responseType: "blob",
      headers: { Authorization: token },
    })
    .then((response) => {
      const pdfUrl = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = pdfUrl;
      a.setAttribute("download", `${filename}`);
      document.body.appendChild(a);
      a.click();
      a.remove();
    })
    .catch((error) => {
      return Promise.reject(error);
    });

export const dateFormat = (value) => {
  const d = new Date(value);
  let month = d.getMonth() + 1;
  let day = d.getDate();
  const year = d.getFullYear();

  if (month.toString().length < 2) month = `0${month}`;
  if (day.toString().length < 2) day = `0${day}`;

  return [day, month, year].join("/");
};

export const compareArrays = (array1, array2) => {
  if (array1.length !== array2.length) {
    return false;
  }

  const sortedArray1 = _.sortBy(array1, (obj) =>
    JSON.stringify(_.omit(obj, "key"))
  );
  const sortedArray2 = _.sortBy(array2, (obj) =>
    JSON.stringify(_.omit(obj, "key"))
  );

  for (let i = 0; i < sortedArray1.length; i++) {
    const obj1 = sortedArray1[i];
    const obj2 = sortedArray2[i];
    if (!_.isEqual(_.omit(obj1, "key"), _.omit(obj2, "key"))) {
      return false;
    }
  }

  return true;
};

export const parseLength = (lengthStr) => {
  if (lengthStr !== null) {
    if (lengthStr.includes("'")) {
      const parts = lengthStr.split("'");
      const feet = parseInt(parts[0]);
      const inches = parseFloat(parts[1].replace('"', ""));
      return feet * 12 + inches;
    } else {
      const parts = lengthStr.split("-");
      const feet = parseInt(parts[0]);
      const inches = parseInt(parts[1].split(" ")[0]);
      const fraction = parts[1].split(" ")[1] || "0/1";
      const fractionParts = fraction.split("/");
      const numerator = parseInt(fractionParts[0]);
      const denominator = parseInt(fractionParts[1]) || 1;
      const decimal = numerator / denominator;
      return feet * 12 + inches + decimal;
    }
  }
};

export const formatLength = (lengthInches) => {
  if (lengthInches) {
    const feet = Math.floor(lengthInches / 12);
    const inches = Math.round(lengthInches % 12);
    const fraction = lengthInches % 1;
    const denominator = 16;
    const numerator = Math.round(fraction * denominator);
    const fractionStr = `${numerator}/${denominator}`;
    return `${feet}'${inches} ${fractionStr}"`;
  }
};

export const commify = (n) => {
  var parts = n.toString().split(",");
  const numberPart = parts[0];
  const decimalPart = parts[1];
  const thousands = /\B(?=(\d{3})+(?!\d))/g;
  return (
    numberPart.replace(thousands, ",") + (decimalPart ? "." + decimalPart : "")
  );
};

export const formatPriceToDollar = (price) => {
  return price.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
};

export const getSequentialCardStyles = (categoryId) => {
  const adjustedCategoryId = (categoryId - 1) % Object.keys(styleMap).length + 1; 
  return styleMap[adjustedCategoryId];
};

const styleMap = {
  1: { background: theme.colors.red, color: theme.colors.white, backgroundLight: theme.colors.red50 }, 
  2: { background: theme.colors.green300, color: theme.colors.white, backgroundLight: theme.colors.white300 }, 
  3: { background: theme.colors.yellowlight, color: theme.colors.gray300, backgroundLight: theme.colors.yellow50 },
};

export const nameLength = 100;
export const emailLength = 100;
export const phoneLength = 15;
export const passwordLength = 16;
export const timeSkeleton = 800;
export const SPECIAL_HOBBY_ID = 143;
export const SPECIAL_PETS_ID = 120;  

//TIPO DE ENCUESTAS
export const internal = "internal";
export const external = "external";

export const getIdSurveyExternal = (typeSurveys) => {
  const survey = typeSurveys.find((type) => type.code == external);
  return survey ? survey.value : 0;
}

export const getIdSurveyInternal = (typeSurveys) => {
  const survey = typeSurveys.find((type) => type.code == internal);
  return survey ? survey.value : 0;
}

//ESTADO DE LAS ENCUESTAS
export const pending = "pending";
export const completed = "completed";
export const open = "open";
export const active = "active";
export const incomplete = "incomplete";

export const getIdSurveyStatusIncomplete = (statusSurveys) => {
  const survey = statusSurveys.find((type) => type.code == incomplete);
  return survey ? survey.value : 0;
}

export const getIdSurveyStatusPending = (statusSurveys) => {
  const survey = statusSurveys.find((type) => type.code == pending);
  return survey ? survey.value : 0;
}
export const getIdSurveyStatusCompleted = (statusSurveys) => {
  const survey = statusSurveys.find((type) => type.code == completed);
  return survey ? survey.value : 0;
}
export const getIdSurveyStatusActive = (statusSurveys) => {
  const survey = statusSurveys.find((type) => type.code == active);
  return survey ? survey.value : 0;
}

export const getIdSurveyStatusOpen = (statusSurveys) => {
  const survey = statusSurveys.find((type) => type.code == open);
  return survey ? survey.value : 0;
}

export const calculateAge = (birthdate) => {
  if (!birthdate) return null; // Si no hay fecha de nacimiento, retorna null

  // Convertir la fecha de nacimiento a un objeto Date
  const [day, month, year] = birthdate.split('/');
  const birthDate = new Date(`${year}-${month}-${day}`);

  // Obtener la fecha actual
  const today = new Date();

  // Calcular la edad
  let age = today.getFullYear() - birthDate.getFullYear();

  // Ajustar si aún no ha pasado el cumpleaños este año
  const monthDifference = today.getMonth() - birthDate.getMonth();
  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

export const containsHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str);
